import * as React from 'react';
import classnames from '../../core/utils/classnames.tsx';
import { useTranslation } from 'react-i18next';

interface TextChartProps {
    value: string | number;
    unit?: string;
    className?: string;
}

const TextChart = ({ value, unit, className }: TextChartProps) => {
    const { i18n } = useTranslation();
    const formattedValue = value.toLocaleString(i18n.language);
    return (
        <div className="w-full h-full flex justify-center items-center">
            <span className={classnames('py-5 flex gap-1 justify-center items-center', className)}>
                <span className="font-medium text-5xl text-content-strong text-center">{formattedValue}</span>
                {unit ? (
                    <span className="font-normal text-content-medium text-2xl mt-0.5 inline-block">{unit}</span>
                ) : null}
            </span>
        </div>
    );
};

export default TextChart;
